import { deleteTaskFilterGroup } from '@dispatch/shared/services';
import { useMutation } from 'react-query';

export const useDeleteTaskFilterGroup = (
  userId: string,
  onSuccess: () => void
) => {
  const { mutate, error, status } = useMutation(
    ['delete-filter-group', userId],
    async (groupId: string) => deleteTaskFilterGroup(userId, groupId),
    {
      onSuccess,
    }
  );

  return {
    deleteTaskFilterGroup: mutate,
    error,
    status,
  };
};
